// Generated from C:/Code/IDM Web App 2/src/app/shared/xpath-parser\xpath.g4 by ANTLR 4.8
// jshint ignore: start
import antlr4 from '../../utils/interop/antlr4';

const serializedATN = [
  4, 0, 36, 448, 6, -1, 2, 0, 7, 0, 2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7, 4, 2, 5, 7, 5, 2,
  6, 7, 6, 2, 7, 7, 7, 2, 8, 7, 8, 2, 9, 7, 9, 2, 10, 7, 10, 2, 11, 7, 11, 2, 12, 7, 12, 2, 13, 7,
  13, 2, 14, 7, 14, 2, 15, 7, 15, 2, 16, 7, 16, 2, 17, 7, 17, 2, 18, 7, 18, 2, 19, 7, 19, 2, 20, 7,
  20, 2, 21, 7, 21, 2, 22, 7, 22, 2, 23, 7, 23, 2, 24, 7, 24, 2, 25, 7, 25, 2, 26, 7, 26, 2, 27, 7,
  27, 2, 28, 7, 28, 2, 29, 7, 29, 2, 30, 7, 30, 2, 31, 7, 31, 2, 32, 7, 32, 2, 33, 7, 33, 2, 34, 7,
  34, 2, 35, 7, 35, 1, 0, 1, 0, 1, 1, 1, 1, 1, 2, 1, 2, 1, 3, 1, 3, 1, 4, 1, 4, 1, 5, 1, 5, 1, 5, 1,
  6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 8, 1, 8, 1, 8, 1, 8, 1, 8, 1, 9,
  1, 9, 1, 9, 1, 9, 1, 9, 1, 9, 1, 10, 1, 10, 1, 10, 1, 10, 1, 10, 1, 11, 1, 11, 1, 11, 1, 11, 1,
  11, 1, 11, 1, 12, 1, 12, 1, 12, 1, 13, 1, 13, 1, 14, 1, 14, 1, 14, 1, 15, 1, 15, 1, 16, 1, 16, 1,
  16, 1, 16, 1, 16, 1, 16, 1, 17, 1, 17, 1, 17, 1, 17, 1, 17, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1,
  18, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 20, 1, 20, 1, 21, 1, 21, 1, 22, 1, 22, 1, 22, 1, 22, 1,
  23, 1, 23, 1, 23, 1, 24, 1, 24, 1, 25, 1, 25, 1, 26, 4, 26, 168, 8, 26, 11, 26, 12, 26, 169, 1,
  26, 1, 26, 1, 27, 1, 27, 1, 27, 3, 27, 177, 8, 27, 1, 27, 1, 27, 1, 28, 1, 28, 1, 28, 1, 28, 1,
  28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1,
  28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1,
  28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1,
  28, 3, 28, 228, 8, 28, 1, 29, 1, 29, 1, 29, 3, 29, 233, 8, 29, 1, 29, 1, 29, 1, 30, 1, 30, 1, 30,
  1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30,
  1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30,
  1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30,
  1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30,
  1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30,
  1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30,
  1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30,
  1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30,
  1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30,
  1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 3, 30,
  379, 8, 30, 1, 31, 1, 31, 1, 31, 3, 31, 384, 8, 31, 1, 31, 1, 31, 1, 32, 1, 32, 1, 32, 1, 32, 1,
  32, 1, 32, 1, 32, 1, 32, 1, 32, 1, 32, 1, 32, 1, 32, 1, 32, 1, 32, 1, 32, 1, 32, 1, 32, 1, 32, 1,
  32, 1, 32, 1, 32, 1, 32, 1, 32, 3, 32, 411, 8, 32, 1, 33, 1, 33, 5, 33, 415, 8, 33, 10, 33, 12,
  33, 418, 9, 33, 1, 34, 4, 34, 421, 8, 34, 11, 34, 12, 34, 422, 1, 34, 1, 34, 4, 34, 427, 8, 34,
  11, 34, 12, 34, 428, 3, 34, 431, 8, 34, 1, 35, 1, 35, 4, 35, 435, 8, 35, 11, 35, 12, 35, 436, 1,
  35, 1, 35, 1, 35, 4, 35, 442, 8, 35, 11, 35, 12, 35, 443, 1, 35, 3, 35, 447, 8, 35, 0, 0, 36, 1,
  1, 3, 2, 5, 3, 7, 4, 9, 5, 11, 6, 13, 7, 15, 8, 17, 9, 19, 10, 21, 11, 23, 12, 25, 13, 27, 14, 29,
  15, 31, 16, 33, 17, 35, 18, 37, 19, 39, 20, 41, 21, 43, 22, 45, 23, 47, 24, 49, 25, 51, 26, 53,
  27, 55, 28, 57, 29, 59, 30, 61, 31, 63, 32, 65, 33, 67, 34, 69, 35, 71, 36, 1, 0, 6, 2, 0, 9, 9,
  32, 32, 4, 0, 58, 58, 65, 90, 95, 95, 97, 122, 5, 0, 45, 46, 48, 58, 65, 90, 95, 95, 97, 122, 1,
  0, 48, 57, 1, 0, 34, 34, 1, 0, 39, 39, 466, 0, 1, 1, 0, 0, 0, 0, 3, 1, 0, 0, 0, 0, 5, 1, 0, 0, 0,
  0, 7, 1, 0, 0, 0, 0, 9, 1, 0, 0, 0, 0, 11, 1, 0, 0, 0, 0, 13, 1, 0, 0, 0, 0, 15, 1, 0, 0, 0, 0,
  17, 1, 0, 0, 0, 0, 19, 1, 0, 0, 0, 0, 21, 1, 0, 0, 0, 0, 23, 1, 0, 0, 0, 0, 25, 1, 0, 0, 0, 0, 27,
  1, 0, 0, 0, 0, 29, 1, 0, 0, 0, 0, 31, 1, 0, 0, 0, 0, 33, 1, 0, 0, 0, 0, 35, 1, 0, 0, 0, 0, 37, 1,
  0, 0, 0, 0, 39, 1, 0, 0, 0, 0, 41, 1, 0, 0, 0, 0, 43, 1, 0, 0, 0, 0, 45, 1, 0, 0, 0, 0, 47, 1, 0,
  0, 0, 0, 49, 1, 0, 0, 0, 0, 51, 1, 0, 0, 0, 0, 53, 1, 0, 0, 0, 0, 55, 1, 0, 0, 0, 0, 57, 1, 0, 0,
  0, 0, 59, 1, 0, 0, 0, 0, 61, 1, 0, 0, 0, 0, 63, 1, 0, 0, 0, 0, 65, 1, 0, 0, 0, 0, 67, 1, 0, 0, 0,
  0, 69, 1, 0, 0, 0, 0, 71, 1, 0, 0, 0, 1, 73, 1, 0, 0, 0, 3, 75, 1, 0, 0, 0, 5, 77, 1, 0, 0, 0, 7,
  79, 1, 0, 0, 0, 9, 81, 1, 0, 0, 0, 11, 83, 1, 0, 0, 0, 13, 86, 1, 0, 0, 0, 15, 91, 1, 0, 0, 0, 17,
  97, 1, 0, 0, 0, 19, 102, 1, 0, 0, 0, 21, 108, 1, 0, 0, 0, 23, 113, 1, 0, 0, 0, 25, 119, 1, 0, 0,
  0, 27, 122, 1, 0, 0, 0, 29, 124, 1, 0, 0, 0, 31, 127, 1, 0, 0, 0, 33, 129, 1, 0, 0, 0, 35, 135, 1,
  0, 0, 0, 37, 140, 1, 0, 0, 0, 39, 146, 1, 0, 0, 0, 41, 151, 1, 0, 0, 0, 43, 153, 1, 0, 0, 0, 45,
  155, 1, 0, 0, 0, 47, 159, 1, 0, 0, 0, 49, 162, 1, 0, 0, 0, 51, 164, 1, 0, 0, 0, 53, 167, 1, 0, 0,
  0, 55, 176, 1, 0, 0, 0, 57, 227, 1, 0, 0, 0, 59, 232, 1, 0, 0, 0, 61, 378, 1, 0, 0, 0, 63, 383, 1,
  0, 0, 0, 65, 410, 1, 0, 0, 0, 67, 412, 1, 0, 0, 0, 69, 430, 1, 0, 0, 0, 71, 446, 1, 0, 0, 0, 73,
  74, 5, 124, 0, 0, 74, 2, 1, 0, 0, 0, 75, 76, 5, 47, 0, 0, 76, 4, 1, 0, 0, 0, 77, 78, 5, 91, 0, 0,
  78, 6, 1, 0, 0, 0, 79, 80, 5, 93, 0, 0, 80, 8, 1, 0, 0, 0, 81, 82, 5, 61, 0, 0, 82, 10, 1, 0, 0,
  0, 83, 84, 5, 33, 0, 0, 84, 85, 5, 61, 0, 0, 85, 12, 1, 0, 0, 0, 86, 87, 5, 116, 0, 0, 87, 88, 5,
  114, 0, 0, 88, 89, 5, 117, 0, 0, 89, 90, 5, 101, 0, 0, 90, 14, 1, 0, 0, 0, 91, 92, 5, 102, 0, 0,
  92, 93, 5, 97, 0, 0, 93, 94, 5, 108, 0, 0, 94, 95, 5, 115, 0, 0, 95, 96, 5, 101, 0, 0, 96, 16, 1,
  0, 0, 0, 97, 98, 5, 84, 0, 0, 98, 99, 5, 114, 0, 0, 99, 100, 5, 117, 0, 0, 100, 101, 5, 101, 0, 0,
  101, 18, 1, 0, 0, 0, 102, 103, 5, 70, 0, 0, 103, 104, 5, 97, 0, 0, 104, 105, 5, 108, 0, 0, 105,
  106, 5, 115, 0, 0, 106, 107, 5, 101, 0, 0, 107, 20, 1, 0, 0, 0, 108, 109, 5, 84, 0, 0, 109, 110,
  5, 82, 0, 0, 110, 111, 5, 85, 0, 0, 111, 112, 5, 69, 0, 0, 112, 22, 1, 0, 0, 0, 113, 114, 5, 70,
  0, 0, 114, 115, 5, 65, 0, 0, 115, 116, 5, 76, 0, 0, 116, 117, 5, 83, 0, 0, 117, 118, 5, 69, 0, 0,
  118, 24, 1, 0, 0, 0, 119, 120, 5, 60, 0, 0, 120, 121, 5, 61, 0, 0, 121, 26, 1, 0, 0, 0, 122, 123,
  5, 60, 0, 0, 123, 28, 1, 0, 0, 0, 124, 125, 5, 62, 0, 0, 125, 126, 5, 61, 0, 0, 126, 30, 1, 0, 0,
  0, 127, 128, 5, 62, 0, 0, 128, 32, 1, 0, 0, 0, 129, 130, 5, 38, 0, 0, 130, 131, 5, 108, 0, 0, 131,
  132, 5, 116, 0, 0, 132, 133, 5, 59, 0, 0, 133, 134, 5, 61, 0, 0, 134, 34, 1, 0, 0, 0, 135, 136, 5,
  38, 0, 0, 136, 137, 5, 108, 0, 0, 137, 138, 5, 116, 0, 0, 138, 139, 5, 59, 0, 0, 139, 36, 1, 0, 0,
  0, 140, 141, 5, 38, 0, 0, 141, 142, 5, 103, 0, 0, 142, 143, 5, 116, 0, 0, 143, 144, 5, 59, 0, 0,
  144, 145, 5, 61, 0, 0, 145, 38, 1, 0, 0, 0, 146, 147, 5, 38, 0, 0, 147, 148, 5, 103, 0, 0, 148,
  149, 5, 116, 0, 0, 149, 150, 5, 59, 0, 0, 150, 40, 1, 0, 0, 0, 151, 152, 5, 40, 0, 0, 152, 42, 1,
  0, 0, 0, 153, 154, 5, 41, 0, 0, 154, 44, 1, 0, 0, 0, 155, 156, 5, 97, 0, 0, 156, 157, 5, 110, 0,
  0, 157, 158, 5, 100, 0, 0, 158, 46, 1, 0, 0, 0, 159, 160, 5, 111, 0, 0, 160, 161, 5, 114, 0, 0,
  161, 48, 1, 0, 0, 0, 162, 163, 5, 44, 0, 0, 163, 50, 1, 0, 0, 0, 164, 165, 5, 42, 0, 0, 165, 52,
  1, 0, 0, 0, 166, 168, 7, 0, 0, 0, 167, 166, 1, 0, 0, 0, 168, 169, 1, 0, 0, 0, 169, 167, 1, 0, 0,
  0, 169, 170, 1, 0, 0, 0, 170, 171, 1, 0, 0, 0, 171, 172, 6, 26, 0, 0, 172, 54, 1, 0, 0, 0, 173,
  174, 5, 102, 0, 0, 174, 175, 5, 110, 0, 0, 175, 177, 5, 58, 0, 0, 176, 173, 1, 0, 0, 0, 176, 177,
  1, 0, 0, 0, 177, 178, 1, 0, 0, 0, 178, 179, 3, 57, 28, 0, 179, 56, 1, 0, 0, 0, 180, 181, 5, 99, 0,
  0, 181, 182, 5, 111, 0, 0, 182, 183, 5, 110, 0, 0, 183, 184, 5, 116, 0, 0, 184, 185, 5, 97, 0, 0,
  185, 186, 5, 105, 0, 0, 186, 187, 5, 110, 0, 0, 187, 228, 5, 115, 0, 0, 188, 189, 5, 115, 0, 0,
  189, 190, 5, 116, 0, 0, 190, 191, 5, 97, 0, 0, 191, 192, 5, 114, 0, 0, 192, 193, 5, 116, 0, 0,
  193, 194, 5, 115, 0, 0, 194, 195, 5, 45, 0, 0, 195, 196, 5, 119, 0, 0, 196, 197, 5, 105, 0, 0,
  197, 198, 5, 116, 0, 0, 198, 228, 5, 104, 0, 0, 199, 200, 5, 101, 0, 0, 200, 201, 5, 110, 0, 0,
  201, 202, 5, 100, 0, 0, 202, 203, 5, 115, 0, 0, 203, 204, 5, 45, 0, 0, 204, 205, 5, 119, 0, 0,
  205, 206, 5, 105, 0, 0, 206, 207, 5, 116, 0, 0, 207, 228, 5, 104, 0, 0, 208, 209, 5, 99, 0, 0,
  209, 210, 5, 117, 0, 0, 210, 211, 5, 114, 0, 0, 211, 212, 5, 114, 0, 0, 212, 213, 5, 101, 0, 0,
  213, 214, 5, 110, 0, 0, 214, 215, 5, 116, 0, 0, 215, 216, 5, 45, 0, 0, 216, 217, 5, 100, 0, 0,
  217, 218, 5, 97, 0, 0, 218, 219, 5, 116, 0, 0, 219, 220, 5, 101, 0, 0, 220, 221, 5, 84, 0, 0, 221,
  222, 5, 105, 0, 0, 222, 223, 5, 109, 0, 0, 223, 228, 5, 101, 0, 0, 224, 225, 5, 110, 0, 0, 225,
  226, 5, 111, 0, 0, 226, 228, 5, 116, 0, 0, 227, 180, 1, 0, 0, 0, 227, 188, 1, 0, 0, 0, 227, 199,
  1, 0, 0, 0, 227, 208, 1, 0, 0, 0, 227, 224, 1, 0, 0, 0, 228, 58, 1, 0, 0, 0, 229, 230, 5, 111, 0,
  0, 230, 231, 5, 112, 0, 0, 231, 233, 5, 58, 0, 0, 232, 229, 1, 0, 0, 0, 232, 233, 1, 0, 0, 0, 233,
  234, 1, 0, 0, 0, 234, 235, 3, 61, 30, 0, 235, 60, 1, 0, 0, 0, 236, 237, 5, 97, 0, 0, 237, 238, 5,
  100, 0, 0, 238, 239, 5, 100, 0, 0, 239, 240, 5, 45, 0, 0, 240, 241, 5, 100, 0, 0, 241, 242, 5, 97,
  0, 0, 242, 243, 5, 121, 0, 0, 243, 244, 5, 84, 0, 0, 244, 245, 5, 105, 0, 0, 245, 246, 5, 109, 0,
  0, 246, 247, 5, 101, 0, 0, 247, 248, 5, 68, 0, 0, 248, 249, 5, 117, 0, 0, 249, 250, 5, 114, 0, 0,
  250, 251, 5, 97, 0, 0, 251, 252, 5, 116, 0, 0, 252, 253, 5, 105, 0, 0, 253, 254, 5, 111, 0, 0,
  254, 255, 5, 110, 0, 0, 255, 256, 5, 45, 0, 0, 256, 257, 5, 116, 0, 0, 257, 258, 5, 111, 0, 0,
  258, 259, 5, 45, 0, 0, 259, 260, 5, 100, 0, 0, 260, 261, 5, 97, 0, 0, 261, 262, 5, 116, 0, 0, 262,
  263, 5, 101, 0, 0, 263, 264, 5, 84, 0, 0, 264, 265, 5, 105, 0, 0, 265, 266, 5, 109, 0, 0, 266,
  379, 5, 101, 0, 0, 267, 268, 5, 97, 0, 0, 268, 269, 5, 100, 0, 0, 269, 270, 5, 100, 0, 0, 270,
  271, 5, 45, 0, 0, 271, 272, 5, 121, 0, 0, 272, 273, 5, 101, 0, 0, 273, 274, 5, 97, 0, 0, 274, 275,
  5, 114, 0, 0, 275, 276, 5, 77, 0, 0, 276, 277, 5, 111, 0, 0, 277, 278, 5, 110, 0, 0, 278, 279, 5,
  116, 0, 0, 279, 280, 5, 104, 0, 0, 280, 281, 5, 68, 0, 0, 281, 282, 5, 117, 0, 0, 282, 283, 5,
  114, 0, 0, 283, 284, 5, 97, 0, 0, 284, 285, 5, 116, 0, 0, 285, 286, 5, 105, 0, 0, 286, 287, 5,
  111, 0, 0, 287, 288, 5, 110, 0, 0, 288, 289, 5, 45, 0, 0, 289, 290, 5, 116, 0, 0, 290, 291, 5,
  111, 0, 0, 291, 292, 5, 45, 0, 0, 292, 293, 5, 100, 0, 0, 293, 294, 5, 97, 0, 0, 294, 295, 5, 116,
  0, 0, 295, 296, 5, 101, 0, 0, 296, 297, 5, 84, 0, 0, 297, 298, 5, 105, 0, 0, 298, 299, 5, 109, 0,
  0, 299, 379, 5, 101, 0, 0, 300, 301, 5, 115, 0, 0, 301, 302, 5, 117, 0, 0, 302, 303, 5, 98, 0, 0,
  303, 304, 5, 116, 0, 0, 304, 305, 5, 114, 0, 0, 305, 306, 5, 97, 0, 0, 306, 307, 5, 99, 0, 0, 307,
  308, 5, 116, 0, 0, 308, 309, 5, 45, 0, 0, 309, 310, 5, 100, 0, 0, 310, 311, 5, 97, 0, 0, 311, 312,
  5, 121, 0, 0, 312, 313, 5, 84, 0, 0, 313, 314, 5, 105, 0, 0, 314, 315, 5, 109, 0, 0, 315, 316, 5,
  101, 0, 0, 316, 317, 5, 68, 0, 0, 317, 318, 5, 117, 0, 0, 318, 319, 5, 114, 0, 0, 319, 320, 5, 97,
  0, 0, 320, 321, 5, 116, 0, 0, 321, 322, 5, 105, 0, 0, 322, 323, 5, 111, 0, 0, 323, 324, 5, 110, 0,
  0, 324, 325, 5, 45, 0, 0, 325, 326, 5, 102, 0, 0, 326, 327, 5, 114, 0, 0, 327, 328, 5, 111, 0, 0,
  328, 329, 5, 109, 0, 0, 329, 330, 5, 45, 0, 0, 330, 331, 5, 100, 0, 0, 331, 332, 5, 97, 0, 0, 332,
  333, 5, 116, 0, 0, 333, 334, 5, 101, 0, 0, 334, 335, 5, 84, 0, 0, 335, 336, 5, 105, 0, 0, 336,
  337, 5, 109, 0, 0, 337, 379, 5, 101, 0, 0, 338, 339, 5, 115, 0, 0, 339, 340, 5, 117, 0, 0, 340,
  341, 5, 98, 0, 0, 341, 342, 5, 116, 0, 0, 342, 343, 5, 114, 0, 0, 343, 344, 5, 97, 0, 0, 344, 345,
  5, 99, 0, 0, 345, 346, 5, 116, 0, 0, 346, 347, 5, 45, 0, 0, 347, 348, 5, 121, 0, 0, 348, 349, 5,
  101, 0, 0, 349, 350, 5, 97, 0, 0, 350, 351, 5, 114, 0, 0, 351, 352, 5, 77, 0, 0, 352, 353, 5, 111,
  0, 0, 353, 354, 5, 110, 0, 0, 354, 355, 5, 116, 0, 0, 355, 356, 5, 104, 0, 0, 356, 357, 5, 68, 0,
  0, 357, 358, 5, 117, 0, 0, 358, 359, 5, 114, 0, 0, 359, 360, 5, 97, 0, 0, 360, 361, 5, 116, 0, 0,
  361, 362, 5, 105, 0, 0, 362, 363, 5, 111, 0, 0, 363, 364, 5, 110, 0, 0, 364, 365, 5, 45, 0, 0,
  365, 366, 5, 102, 0, 0, 366, 367, 5, 114, 0, 0, 367, 368, 5, 111, 0, 0, 368, 369, 5, 109, 0, 0,
  369, 370, 5, 45, 0, 0, 370, 371, 5, 100, 0, 0, 371, 372, 5, 97, 0, 0, 372, 373, 5, 116, 0, 0, 373,
  374, 5, 101, 0, 0, 374, 375, 5, 84, 0, 0, 375, 376, 5, 105, 0, 0, 376, 377, 5, 109, 0, 0, 377,
  379, 5, 101, 0, 0, 378, 236, 1, 0, 0, 0, 378, 267, 1, 0, 0, 0, 378, 300, 1, 0, 0, 0, 378, 338, 1,
  0, 0, 0, 379, 62, 1, 0, 0, 0, 380, 381, 5, 120, 0, 0, 381, 382, 5, 115, 0, 0, 382, 384, 5, 58, 0,
  0, 383, 380, 1, 0, 0, 0, 383, 384, 1, 0, 0, 0, 384, 385, 1, 0, 0, 0, 385, 386, 3, 65, 32, 0, 386,
  64, 1, 0, 0, 0, 387, 388, 5, 100, 0, 0, 388, 389, 5, 97, 0, 0, 389, 390, 5, 116, 0, 0, 390, 391,
  5, 101, 0, 0, 391, 392, 5, 84, 0, 0, 392, 393, 5, 105, 0, 0, 393, 394, 5, 109, 0, 0, 394, 411, 5,
  101, 0, 0, 395, 396, 5, 100, 0, 0, 396, 397, 5, 97, 0, 0, 397, 398, 5, 121, 0, 0, 398, 399, 5, 84,
  0, 0, 399, 400, 5, 105, 0, 0, 400, 401, 5, 109, 0, 0, 401, 402, 5, 101, 0, 0, 402, 403, 5, 68, 0,
  0, 403, 404, 5, 117, 0, 0, 404, 405, 5, 114, 0, 0, 405, 406, 5, 97, 0, 0, 406, 407, 5, 116, 0, 0,
  407, 408, 5, 105, 0, 0, 408, 409, 5, 111, 0, 0, 409, 411, 5, 110, 0, 0, 410, 387, 1, 0, 0, 0, 410,
  395, 1, 0, 0, 0, 411, 66, 1, 0, 0, 0, 412, 416, 7, 1, 0, 0, 413, 415, 7, 2, 0, 0, 414, 413, 1, 0,
  0, 0, 415, 418, 1, 0, 0, 0, 416, 414, 1, 0, 0, 0, 416, 417, 1, 0, 0, 0, 417, 68, 1, 0, 0, 0, 418,
  416, 1, 0, 0, 0, 419, 421, 7, 3, 0, 0, 420, 419, 1, 0, 0, 0, 421, 422, 1, 0, 0, 0, 422, 420, 1, 0,
  0, 0, 422, 423, 1, 0, 0, 0, 423, 431, 1, 0, 0, 0, 424, 426, 5, 45, 0, 0, 425, 427, 7, 3, 0, 0,
  426, 425, 1, 0, 0, 0, 427, 428, 1, 0, 0, 0, 428, 426, 1, 0, 0, 0, 428, 429, 1, 0, 0, 0, 429, 431,
  1, 0, 0, 0, 430, 420, 1, 0, 0, 0, 430, 424, 1, 0, 0, 0, 431, 70, 1, 0, 0, 0, 432, 434, 5, 34, 0,
  0, 433, 435, 8, 4, 0, 0, 434, 433, 1, 0, 0, 0, 435, 436, 1, 0, 0, 0, 436, 434, 1, 0, 0, 0, 436,
  437, 1, 0, 0, 0, 437, 438, 1, 0, 0, 0, 438, 447, 5, 34, 0, 0, 439, 441, 5, 39, 0, 0, 440, 442, 8,
  5, 0, 0, 441, 440, 1, 0, 0, 0, 442, 443, 1, 0, 0, 0, 443, 441, 1, 0, 0, 0, 443, 444, 1, 0, 0, 0,
  444, 445, 1, 0, 0, 0, 445, 447, 5, 39, 0, 0, 446, 432, 1, 0, 0, 0, 446, 439, 1, 0, 0, 0, 447, 72,
  1, 0, 0, 0, 15, 0, 169, 176, 227, 232, 378, 383, 410, 416, 422, 428, 430, 436, 443, 446, 1, 6, 0,
  0,
];

const atn = new antlr4.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map((ds, index) => new antlr4.DFA(ds, index));

export default class xpathLexer extends antlr4.Lexer {
  static grammarFileName = 'xpath.g4';
  static channelNames = ['DEFAULT_TOKEN_CHANNEL', 'HIDDEN'];
  static modeNames = ['DEFAULT_MODE'];
  static literalNames = [
    null,
    "'|'",
    "'/'",
    "'['",
    "']'",
    "'='",
    "'!='",
    "'true'",
    "'false'",
    "'True'",
    "'False'",
    "'TRUE'",
    "'FALSE'",
    "'<='",
    "'<'",
    "'>='",
    "'>'",
    "'&lt;='",
    "'&lt;'",
    "'&gt;='",
    "'&gt;'",
    "'('",
    "')'",
    "'and'",
    "'or'",
    "','",
    "'*'",
  ];
  static symbolicNames = [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    'WS',
    'FnFunction',
    'FnFunctionName',
    'OpFunction',
    'OpFunctionName',
    'XsFunction',
    'XsFunctionName',
    'QNAME',
    'NUMBER',
    'STRING',
  ];
  static ruleNames = [
    'T__0',
    'T__1',
    'T__2',
    'T__3',
    'T__4',
    'T__5',
    'T__6',
    'T__7',
    'T__8',
    'T__9',
    'T__10',
    'T__11',
    'T__12',
    'T__13',
    'T__14',
    'T__15',
    'T__16',
    'T__17',
    'T__18',
    'T__19',
    'T__20',
    'T__21',
    'T__22',
    'T__23',
    'T__24',
    'T__25',
    'WS',
    'FnFunction',
    'FnFunctionName',
    'OpFunction',
    'OpFunctionName',
    'XsFunction',
    'XsFunctionName',
    'QNAME',
    'NUMBER',
    'STRING',
  ];

  constructor(input) {
    super(input);
    this._interp = new antlr4.LexerATNSimulator(
      this,
      atn,
      decisionsToDFA,
      new antlr4.PredictionContextCache(),
    );
  }
}

xpathLexer.EOF = antlr4.Token.EOF;
xpathLexer.T__0 = 1;
xpathLexer.T__1 = 2;
xpathLexer.T__2 = 3;
xpathLexer.T__3 = 4;
xpathLexer.T__4 = 5;
xpathLexer.T__5 = 6;
xpathLexer.T__6 = 7;
xpathLexer.T__7 = 8;
xpathLexer.T__8 = 9;
xpathLexer.T__9 = 10;
xpathLexer.T__10 = 11;
xpathLexer.T__11 = 12;
xpathLexer.T__12 = 13;
xpathLexer.T__13 = 14;
xpathLexer.T__14 = 15;
xpathLexer.T__15 = 16;
xpathLexer.T__16 = 17;
xpathLexer.T__17 = 18;
xpathLexer.T__18 = 19;
xpathLexer.T__19 = 20;
xpathLexer.T__20 = 21;
xpathLexer.T__21 = 22;
xpathLexer.T__22 = 23;
xpathLexer.T__23 = 24;
xpathLexer.T__24 = 25;
xpathLexer.T__25 = 26;
xpathLexer.WS = 27;
xpathLexer.FnFunction = 28;
xpathLexer.FnFunctionName = 29;
xpathLexer.OpFunction = 30;
xpathLexer.OpFunctionName = 31;
xpathLexer.XsFunction = 32;
xpathLexer.XsFunctionName = 33;
xpathLexer.QNAME = 34;
xpathLexer.NUMBER = 35;
xpathLexer.STRING = 36;
